import { AmplitudeCategories, createTrackerForCategory } from "./amplitude";

const trackEvent = createTrackerForCategory(AmplitudeCategories.Dunning);

enum events {
    TrialFailedDialogOpened = "TrialFailedDialogOpened",
    TrialFailedDialogUpgradeClicked = "TrialFailedDialogUpgradeClicked",
    TrialFailedDialogDismissed = "TrialFailedDialogDismissed",
    TrialCanceledDialogOpened = "TrialCanceledDialogOpened",
    TrialCanceledDialogUpgradeClicked = "TrialCanceledDialogUpgradeClicked",
    TrialCanceledDialogDismissed = "TrialCanceledDialogDismissed",
    TrialPausedDialogOpened = "TrialPausedDialogOpened",
    TrialPausedDialogUpdatePaymentMethodClicked = "TrialPausedDialogUpdatePaymentMethodClicked",
    TrialPausedDialogPaymentMethodUpdated = "TrialPausedDialogPaymentMethodUpdated",
    TrialPausedDialogNotNowClicked = "TrialPausedDialogNotNowClicked",
    TrialPausedDialogSwitchWorkspaceClicked = "TrialPausedDialogSwitchWorkspaceClicked",
    TrialPausedDialogCreateWorkspaceClicked = "TrialPausedDialogCreateWorkspaceClicked",
    TrialPausedDialogForMemberOpened = "TrialPausedDialogForMemberOpened",
    TrialPausedDialogForMemberSwitchWorkspaceClicked = "TrialPausedDialogForMemberSwitchWorkspaceClicked",
    TrialPausedDialogForMemberCreateWorkspaceClicked = "TrialPausedDialogForMemberCreateWorkspaceClicked",
    ConfirmSubscriptionChargeDialogOpened = "ConfirmSubscriptionChargeDialogOpened",
    ConfirmSubscriptionChargeDialogChangePaymentMethodClicked = "ConfirmSubscriptionChargeDialogChangePaymentMethodClicked",
    ConfirmSubscriptionChargeDialogPaymentMethodChanged = "ConfirmSubscriptionChargeDialogPaymentMethodChanged",
    ConfirmSubscriptionChargeDialogConfirmPaymentClicked = "ConfirmSubscriptionChargeDialogConfirmPaymentClicked",
    ConfirmSubscriptionChargeDialogPaymentConfirmed = "ConfirmSubscriptionChargeDialogPaymentConfirmed",
    ConfirmSubscriptionChargeDialogPaymentConfirmationFailed = "ConfirmSubscriptionChargeDialogPaymentConfirmationFailed",
    PaymentIssueDialogOpened = "PaymentIssueDialogOpened",
    PaymentIssueDialogDismissed = "PaymentIssueDialogDismissed",
    PaymentIssueDialogUpdatePaymentMethodClicked = "PaymentIssueDialogUpdatePaymentMethodClicked",
    PaymentIssueDialogPaymentMethodUpdated = "PaymentIssueDialogPaymentMethodUpdated",
    SubscriptionCanceledDialogOpened = "SubscriptionCanceledDialogOpened",
    SubscriptionCanceledDialogUpgradeClicked = "SubscriptionCanceledDialogUpgradeClicked",
    SubscriptionCanceledDialogDismissed = "SubscriptionCanceledDialogDismissed",
}

export function TrialFailedDialogOpened() {
    trackEvent(events.TrialFailedDialogOpened, {}, { audit: true });
}

export function TrialFailedDialogUpgradeClicked() {
    trackEvent(events.TrialFailedDialogUpgradeClicked, {}, { audit: true });
}

export function TrialFailedDialogDismissed() {
    trackEvent(events.TrialFailedDialogDismissed, {}, { audit: true });
}

export function TrialCanceledDialogOpened() {
    trackEvent(events.TrialCanceledDialogOpened, {}, { audit: true });
}

export function TrialCanceledDialogUpgradeClicked() {
    trackEvent(events.TrialCanceledDialogUpgradeClicked, {}, { audit: true });
}

export function TrialCanceledDialogDismissed() {
    trackEvent(events.TrialCanceledDialogDismissed, {}, { audit: true });
}

export function TrialPausedDialogOpened() {
    trackEvent(events.TrialPausedDialogOpened, {}, { audit: true });
}

export function TrialPausedDialogUpdatePaymentMethodClicked() {
    trackEvent(events.TrialPausedDialogUpdatePaymentMethodClicked, {}, { audit: true });
}

export function TrialPausedDialogPaymentMethodUpdated() {
    trackEvent(events.TrialPausedDialogPaymentMethodUpdated, {}, { audit: true });
}

export function TrialPausedDialogNotNowClicked() {
    trackEvent(events.TrialPausedDialogNotNowClicked, {}, { audit: true });
}

export function TrialPausedDialogSwitchWorkspaceClicked() {
    trackEvent(events.TrialPausedDialogSwitchWorkspaceClicked, {}, { audit: true });
}

export function TrialPausedDialogCreateWorkspaceClicked() {
    trackEvent(events.TrialPausedDialogCreateWorkspaceClicked, {}, { audit: true });
}

export function TrialPausedDialogForMemberOpened() {
    trackEvent(events.TrialPausedDialogForMemberOpened, {}, { audit: true });
}

export function TrialPausedDialogForMemberSwitchWorkspaceClicked() {
    trackEvent(events.TrialPausedDialogForMemberSwitchWorkspaceClicked, {}, { audit: true });
}

export function TrialPausedDialogForMemberCreateWorkspaceClicked() {
    trackEvent(events.TrialPausedDialogForMemberCreateWorkspaceClicked, {}, { audit: true });
}

export function ConfirmSubscriptionChargeDialogOpened() {
    trackEvent(events.ConfirmSubscriptionChargeDialogOpened, {}, { audit: true });
}

export function ConfirmSubscriptionChargeDialogChangePaymentMethodClicked() {
    trackEvent(events.ConfirmSubscriptionChargeDialogChangePaymentMethodClicked, {}, { audit: true });
}

export function ConfirmSubscriptionChargeDialogConfirmPaymentClicked() {
    trackEvent(events.ConfirmSubscriptionChargeDialogConfirmPaymentClicked, {}, { audit: true });
}

export function ConfirmSubscriptionChargeDialogPaymentConfirmed() {
    trackEvent(events.ConfirmSubscriptionChargeDialogPaymentConfirmed, {}, { audit: true });
}

export function ConfirmSubscriptionChargeDialogPaymentMethodChanged() {
    trackEvent(events.ConfirmSubscriptionChargeDialogPaymentMethodChanged, {}, { audit: true });
}

export function ConfirmSubscriptionChargeDialogPaymentConfirmationFailed() {
    trackEvent(events.ConfirmSubscriptionChargeDialogPaymentConfirmationFailed, {}, { audit: true });
}

export function PaymentIssueDialogOpened() {
    trackEvent(events.PaymentIssueDialogOpened, {}, { audit: true });
}

export function PaymentIssueDialogDismissed() {
    trackEvent(events.PaymentIssueDialogDismissed, {}, { audit: true });
}

export function PaymentIssueDialogUpdatePaymentMethodClicked() {
    trackEvent(events.PaymentIssueDialogUpdatePaymentMethodClicked, {}, { audit: true });
}

export function PaymentIssueDialogPaymentMethodUpdated() {
    trackEvent(events.PaymentIssueDialogPaymentMethodUpdated, {}, { audit: true });
}

export function SubscriptionCanceledDialogOpened() {
    trackEvent(events.SubscriptionCanceledDialogOpened, {}, { audit: true });
}

export function SubscriptionCanceledDialogUpgradeClicked() {
    trackEvent(events.SubscriptionCanceledDialogUpgradeClicked, {}, { audit: true });
}

export function SubscriptionCanceledDialogDismissed() {
    trackEvent(events.SubscriptionCanceledDialogDismissed, {}, { audit: true });
}
